/* Aging Backwards Wellness — shared behaviour:
   header state + pinned-gallery offset, drawers (menu / search / cart),
   ajax add-to-cart, gallery thumbnails, variant + selling-plan price updates. */
(function () {
  "use strict";

  function money(cents, currency) {
    var value = (cents / 100).toFixed(2);
    return currency ? value + " " + currency : "$" + value;
  }

  /* --------------------------------------------------------------- header */
  function initHeader() {
    var header = document.querySelector("[data-ab-header]");
    if (!header) return;
    var last = 0;
    var onScroll = function () {
      var y = window.scrollY || window.pageYOffset;
      var scrolled = y > 120;
      if (scrolled !== (last > 120)) header.classList.toggle("is-scrolled", scrolled);
      last = y;
    };
    var write = function () {
      var h = Math.round(header.getBoundingClientRect().height);
      document.documentElement.style.setProperty("--site-header-h", h + "px");
      document.documentElement.style.setProperty("--ab-gallery-pin-top", (h + 16) + "px");
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", write);
    if (typeof ResizeObserver !== "undefined") new ResizeObserver(write).observe(header);
    onScroll();
    write();
  }

  /* -------------------------------------------------------------- drawers */
    // iOS Safari ignores body overflow:hidden, so pin the page in place while a drawer is open.
  var lockedY = null;
  function lockScroll() {
    if (lockedY !== null) return;
    lockedY = window.scrollY;
    var st = document.body.style;
    st.position = "fixed"; st.top = (-lockedY) + "px"; st.left = "0"; st.right = "0"; st.width = "100%"; st.overflow = "hidden";
  }
  function unlockScroll() {
    if (lockedY === null || document.querySelector("[data-ab-drawer].is-open")) return;
    var st = document.body.style;
    st.position = ""; st.top = ""; st.left = ""; st.right = ""; st.width = ""; st.overflow = "";
    var y = lockedY; lockedY = null;
    window.scrollTo(0, y);
  }
  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove("is-open");
    if (drawer.classList.contains("ab-search")) drawer.setAttribute("aria-hidden", "true");
    unlockScroll();
  }

  function openDrawer(name) {
    document.querySelectorAll("[data-ab-drawer]").forEach(function (d) { closeDrawer(d); });
    var drawer = document.querySelector('[data-ab-drawer="' + name + '"]');
    if (!drawer) return;
    drawer.classList.add("is-open");
    if (name === "cart") loadCart();
    if (name === "search") openSearch(drawer);
    lockScroll();
    var focusable = drawer.querySelector("input, a, button:not([data-ab-close])");
    if (focusable) focusable.focus();
  }

  function initDrawers() {
    document.addEventListener("click", function (e) {
      var opener = e.target.closest("[data-ab-open]");
      if (opener) {
        e.preventDefault();
        openDrawer(opener.getAttribute("data-ab-open"));
        return;
      }
      if (e.target.closest("[data-ab-close]") || e.target.hasAttribute("data-ab-scrim")) {
        closeDrawer(e.target.closest("[data-ab-drawer]"));
      }
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        document.querySelectorAll('[data-ab-drawer].is-open').forEach(closeDrawer);
      }
    });
  }


  /* -------------------------------------------------------------- search
     Mirrors src/components/SearchDrawer.tsx: slides down, topic photos load on
     first open, live results from Shopify predictive search as you type. */
  function openSearch(drawer) {
    drawer.setAttribute("aria-hidden", "false");
    drawer.querySelectorAll("img[data-src]").forEach(function (img) { img.src = img.getAttribute("data-src"); img.removeAttribute("data-src"); });
    var input = drawer.querySelector("[data-ab-search-input]");
    if (input) setTimeout(function () { input.focus(); }, 50);
  }
  function initSearch() {
    var drawer = document.querySelector(".ab-search");
    if (!drawer) return;
    var input = drawer.querySelector("[data-ab-search-input]");
    var clear = drawer.querySelector("[data-ab-search-clear]");
    var topics = drawer.querySelector("[data-ab-search-topics]");
    var box = drawer.querySelector("[data-ab-search-results]");
    var timer = null, seq = 0;
    function e(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
    function hi(text, q) {
      var i = text.toLowerCase().indexOf(q.toLowerCase());
      if (!q || i < 0) return e(text);
      return e(text.slice(0, i)) + "<mark>" + e(text.slice(i, i + q.length)) + "</mark>" + e(text.slice(i + q.length));
    }
    function dollars(v) { var n = Number(v); if (n > 1000 && String(v).indexOf(".") < 0) n = n / 100; return "$" + n.toFixed(2); }
    function list(title, items, q) {
      if (!items.length) return "";
      return '<div><h2 class="font-sans text-lg font-semibold uppercase tracking-wide text-primary">' + title + '</h2><ul class="mt-3 space-y-2 border-b pb-6">' +
        items.map(function (it) { return '<li><a href="' + e(it.url) + '" data-ab-close class="text-lg leading-snug hover:text-accent-text">' + hi(it.title, q) + "</a></li>"; }).join("") + "</ul></div>";
    }
    function render(r, q) {
      var prods = (r.products || []).slice(0, 6);
      var html = '<div class="grid gap-10 lg:grid-cols-[1.4fr_1fr]"><div><h2 class="font-sans text-lg font-semibold uppercase tracking-wide text-primary">Products</h2>';
      if (!prods.length) html += '<p class="mt-4 text-sm text-muted-foreground">No products match \u201c' + e(q) + '\u201d.</p>';
      html += '<div class="mt-5 grid gap-x-8 gap-y-7 sm:grid-cols-2">' + prods.map(function (p) {
        var price = Number(p.price), cmp = Number(p.compare_at_price_max || 0);
        var disc = cmp > price ? Math.round((1 - price / cmp) * 100) : 0;
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
        return '<a href="' + e(p.url) + '" data-ab-close class="group flex items-start gap-4">' + (img ? '<img src="' + e(img) + (String(img).indexOf("?") < 0 ? "?" : "&") + 'width=200" alt="" loading="lazy" class="h-24 w-24 shrink-0 object-contain">' : "") +
          '<span class="min-w-0"><span class="block text-xs uppercase tracking-wide text-muted-foreground">Aging Backwards Wellness</span><span class="mt-1 block text-lg leading-snug text-foreground group-hover:text-accent-text">' + hi(abName(abDecode(p.title)), q) + '</span><span class="mt-1 flex flex-wrap items-center gap-2">' +
          (disc > 0 ? '<span class="text-sm text-muted-foreground line-through">' + dollars(p.compare_at_price_max) + "</span>" : "") +
          '<span class="text-lg ' + (disc > 0 ? "font-semibold text-accent-text" : "text-foreground") + '">' + dollars(p.price) + "</span>" +
          (disc > 0 ? '<span class="rounded-full bg-info-soft px-2 py-0.5 text-xs font-semibold text-primary">-' + disc + "%</span>" : "") + "</span></span></a>";
      }).join("") + "</div>";
      if (prods.length) html += '<a href="/search?q=' + encodeURIComponent(q) + '&type=product" class="mt-8 inline-flex h-11 items-center justify-center rounded-full bg-accent px-8 text-sm font-semibold uppercase tracking-wide text-accent-foreground">View all for \u201c' + e(q) + '\u201d</a>';
      html += '</div><div class="space-y-8 border-t pt-8 lg:border-l lg:border-t-0 lg:pl-10 lg:pt-0">' +
        list("Pages", (r.pages || []).slice(0, 4), q) + list("Articles", (r.articles || []).slice(0, 4), q) + list("Collections", (r.collections || []).slice(0, 4), q);
      if (!prods.length && !(r.pages || []).length && !(r.articles || []).length && !(r.collections || []).length)
        html += '<p class="text-sm text-muted-foreground">Nothing found for \u201c' + e(q) + '\u201d. Try a health goal like \u201cgut\u201d, \u201csleep\u201d, or \u201cenergy\u201d.</p>';
      box.innerHTML = html + "</div></div>";
    }
    function run() {
      var q = input.value.trim();
      clear.classList.toggle("hidden", !input.value); clear.classList.toggle("grid", !!input.value);
      if (!q) { box.classList.add("hidden"); topics.classList.remove("hidden"); return; }
      var my = ++seq;
      /* Products come from the full search page's own matches so the panel and "View all" always agree;
         pages, articles and collections still come from Shopify's suggestions. */
      var suggest = fetch("/search/suggest.json?q=" + encodeURIComponent(q) + "&resources[type]=product,page,article,collection&resources[limit]=6&resources[options][unavailable_products]=last")
        .then(function (res) { return res.json(); });
      var handles = fetch("/search?q=" + encodeURIComponent(q) + "&type=product&section_id=search-results")
        .then(function (res) { return res.text(); })
        .then(function (html) { var m = html.match(/<script type="application\/json" data-ab-search-handles>([\s\S]*?)<\/script>/); return m ? JSON.parse(m[1]) : []; })
        .then(function (list) {
          return Promise.all(list.slice(0, 6).map(function (h) {
            return fetch("/products/" + h + ".js").then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
              return p && { title: p.title, url: "/products/" + p.handle, price: (p.price / 100).toFixed(2), compare_at_price_max: ((p.compare_at_price_max || 0) / 100).toFixed(2), image: p.featured_image };
            }).catch(function () { return null; });
          }));
        });
      Promise.all([suggest, handles])
        .then(function (both) {
          if (my !== seq) return;
          var r = (both[0].resources && both[0].resources.results) || {};
          r.products = both[1].filter(Boolean);
          render(r, q); topics.classList.add("hidden"); box.classList.remove("hidden");
        })
        .catch(function () {});
    }
    input.addEventListener("input", function () { clearTimeout(timer); timer = setTimeout(run, 180); });
    clear.addEventListener("click", function () { input.value = ""; run(); input.focus(); });
  }


  /* ---------------------------------------------------------- newsletter
     Same signup as the site footer: the app's /api/public/newsletter saves the
     email and subscribes it to Klaviyo's Newsletter list (double opt-in). */
  function initNewsletter() {
    document.querySelectorAll("[data-ab-newsletter]").forEach(function (root) {
      var form = root.querySelector("form"), err = root.querySelector("[data-ab-newsletter-error]");
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var btn = form.querySelector("button[type=submit]"), email = form.elements.email.value.trim();
        err.classList.add("hidden");
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { err.textContent = "Please enter a valid email."; err.classList.remove("hidden"); return; }
        btn.disabled = true;
        fetch("https://aging-backwards-wellness.lovable.app/api/public/newsletter", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ email: email, website: form.elements.website.value }) })
          .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.error || "We couldn't sign you up right now. Please try again."); return d; }); })
          .then(function (d) { root.querySelector("[data-ab-newsletter-code]").textContent = d.code || "WELCOME10"; form.classList.add("hidden"); root.querySelector("[data-ab-newsletter-done]").classList.remove("hidden"); })
          .catch(function (x) { err.textContent = x.message || "We couldn't sign you up right now. Please try again."; err.classList.remove("hidden"); })
          .then(function () { btn.disabled = false; });
      });
    });
  }

  /* ---------------------------------------------------------------- cart
     Mirrors src/components/CartDrawer.tsx — free-shipping progress, item rows,
     savings line, total, secure checkout, guarantee box and trust badges. */
  var AB_FREE_SHIPPING = 7500;
  var AB_SUB_FREE_SHIP = ["probio-vitality", "tamis-top-three"];
  var AB_BTN_BASE =
    "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full text-sm font-black uppercase tracking-wider cursor-pointer transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 disabled:cursor-not-allowed [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0";
  var AB_BTN_HERO = AB_BTN_BASE + " border border-transparent bg-accent text-accent-foreground hover:bg-accent/90 h-12 px-6";
  var AB_BTN_OUTLINE_ICON = AB_BTN_BASE + " border border-primary bg-background hover:bg-primary hover:text-primary-foreground h-6 w-6";
  var AB_BTN_GHOST_ICON = AB_BTN_BASE + " hover:bg-accent hover:text-accent-foreground h-6 w-6";
  var AB_SVG_OPEN =
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"';
  var AB_IC_TRASH = AB_SVG_OPEN + ' class="size-4"><path d="M3 6h18"/><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/><line x1="10" x2="10" y1="11" y2="17"/><line x1="14" x2="14" y1="11" y2="17"/></svg>';
  var AB_IC_MINUS = AB_SVG_OPEN + ' class="size-4"><path d="M5 12h14"/></svg>';
  var AB_IC_PLUS = AB_SVG_OPEN + ' class="size-4"><path d="M5 12h14"/><path d="M12 5v14"/></svg>';
  var AB_IC_EXTERNAL = AB_SVG_OPEN + ' class="size-4"><path d="M15 3h6v6"/><path d="M10 14 21 3"/><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/></svg>';
  var AB_IC_SHIELD = AB_SVG_OPEN + ' class="size-4 shrink-0"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/><path d="m9 12 2 2 4-4"/></svg>';
  var AB_IC_PERCENT = AB_SVG_OPEN + ' class="size-4 shrink-0"><path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"/><path d="m9 9 6 6"/><circle cx="9" cy="9" r="2"/><circle cx="15" cy="15" r="2"/></svg>';
  var AB_IC_STETH = AB_SVG_OPEN + ' class="size-4 text-primary"><path d="M11 2v2"/><path d="M5 2v2"/><path d="M5 3H4a2 2 0 0 0-2 2v4a6 6 0 0 0 12 0V5a2 2 0 0 0-2-2h-1"/><path d="M8 15a6 6 0 1 0 12 0v-3"/><circle cx="20" cy="10" r="2"/></svg>';
  var AB_IC_FLASK = AB_SVG_OPEN + ' class="size-4 text-primary"><path d="M10 2v7.527a2 2 0 0 1-.211.896L4.72 20.55a1 1 0 0 0 .9 1.45h12.76a1 1 0 0 0 .9-1.45l-5.069-10.127A2 2 0 0 1 14 9.527V2"/><path d="M8.5 2h7"/><path d="M7 16h10"/></svg>';
  var AB_IC_LOCK = AB_SVG_OPEN + ' class="size-4 text-primary"><rect width="18" height="11" x="3" y="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>';
  /* Same order as snippets/product-name.liquid so longer names win first. */
  var AB_PRODUCTS = [
    "Immune Vitality Max Package", "Elderberry Immune Vitality", "Quercetin Immune Vitality",
    "Immune Vitality Package", "Berberine Gut Vitality", "Neuro Fortify Vitality",
    "Neuro Vitality Package", "D-Immune Vitality Max", "Butyrate Gut Vitality",
    "Neurofortify Vitality", "Nuerofortify Vitality", "Zinc Immune Vitality",
    "Gut Vitality Package", "C-Immune Vitality", "D-Immune Vitality", "IgGI Gut Vitality",
    "Tami's Top Three", "Tami\u2019s Top Three", "Neuro Revitalize", "Probio Vitality",
    "Neuro Package", "Mag Vitality", "DHA Vitality", "Gut Package", "Mag Cleanse",
  ];

  function esc(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  /* Trademark normalisation — mirrors src/lib/product-trademarks.ts. */
  function abName(text) {
    var out = String(text == null ? "" : text);
    var i, base;
    for (i = 0; i < AB_PRODUCTS.length; i++) {
      base = AB_PRODUCTS[i];
      out = out.split(base + "\u2122").join("@@P" + i + "@@")
        .split(base + "\u00AE").join("@@PR" + i + "@@")
        .split(base).join("@@P" + i + "@@");
    }
    for (i = 0; i < AB_PRODUCTS.length; i++) {
      out = out.split("@@P" + i + "@@").join(AB_PRODUCTS[i] + "\u2122")
        .split("@@PR" + i + "@@").join(AB_PRODUCTS[i] + "\u00AE");
    }
    return out;
  }

  /* cart.js returns HTML-escaped strings — decode before normalising. */
  function abDecode(s) {
    var t = document.createElement("textarea");
    t.innerHTML = String(s == null ? "" : s);
    return t.value;
  }

  var AB_CMP = {};
  function renderCart(cart) {
    var wrap = document.querySelector("[data-ab-cart-body]");
    // Free subscription bonus lines ($0) are not shown, matching the site's cart.
    var shown = (cart && cart.items ? cart.items : []).filter(function (i) { return i.final_price > 0; });
    var shownCount = shown.reduce(function (n, i) { return n + i.quantity; }, 0);
    var count = document.querySelector("[data-ab-cart-count]");
    if (count) { count.textContent = shownCount; count.hidden = !shownCount; }
    var desc = document.querySelector("[data-ab-cart-desc]");
    if (desc) {
      desc.textContent = shownCount
        ? shownCount + (shownCount === 1 ? " item" : " items")
        : "Your cart is empty";
    }
    if (!wrap) return;

    if (!shown.length) {
      wrap.innerHTML =
        '<div class="flex flex-1 flex-col items-center justify-center gap-4 text-center text-muted-foreground">' +
        "<p>Nothing here yet.</p>" +
        '<a class="' + AB_BTN_HERO + '" href="/collections/all">Shop the formulas</a>' +
        "</div>";
      return;
    }

    var subFree = cart.items.some(function (item) {
      return item.selling_plan_allocation && AB_SUB_FREE_SHIP.indexOf(item.handle) !== -1;
    });
    var toFree = subFree ? 0 : Math.max(0, AB_FREE_SHIPPING - cart.total_price);
    var shipMsg = toFree > 0
      ? "You're " + money(toFree) + " away from <strong>free shipping</strong>"
      : subFree && cart.total_price < AB_FREE_SHIPPING
        ? "Your subscription includes <strong>free shipping</strong>"
        : "You've unlocked <strong>free shipping</strong>";

    // Subscriptions save against the regular price; one-time items against
    // the variant's compare-at price (cart.js omits it, so fetch per product).
    var savings = 0, missing = [];
    shown.forEach(function (item) {
      var paid = item.final_line_price || item.final_price * item.quantity || 0;
      var ref = item.original_line_price || 0;
      var spa = item.selling_plan_allocation;
      var planRef = spa ? (spa.compare_at_price || spa.price || 0) * item.quantity : 0;
      if (planRef > ref) ref = planRef;
      {
        var cmp = AB_CMP[item.variant_id];
        if (cmp === undefined) { if (missing.indexOf(item.handle) === -1) missing.push(item.handle); }
        else if (cmp > ref / item.quantity) ref = cmp * item.quantity;
      }
      var diff = ref - paid;
      if (diff > 0) savings += diff;
    });
    if (missing.length) {
      Promise.all(missing.map(function (h) {
        return fetch("/products/" + h + ".js").then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) { (p && p.variants || []).forEach(function (v) { AB_CMP[v.id] = v.compare_at_price || 0; }); })
          .catch(function () {});
      })).then(function () {
        cart.items.forEach(function (i) { if (AB_CMP[i.variant_id] === undefined) AB_CMP[i.variant_id] = 0; });
        renderCart(cart);
      });
    }

    var guaranteeUrl = "/pages/100-day-money-back-guarantee";
    var drawer = document.querySelector("[data-ab-drawer='cart']");
    if (drawer && drawer.getAttribute("data-ab-guarantee-url")) {
      guaranteeUrl = drawer.getAttribute("data-ab-guarantee-url");
    }

    wrap.innerHTML =
      '<div class="mb-4 rounded-xl border bg-card p-3">' +
      '<p class="text-sm font-medium text-primary">' + shipMsg + "</p>" +
      '<div class="mt-2 h-2 overflow-hidden rounded-full bg-muted" role="progressbar" aria-valuemin="0" aria-valuemax="75" aria-valuenow="' + (toFree > 0 ? Math.round(cart.total_price / 100) : 75) + '" aria-label="Progress to free shipping">' +
      '<div class="h-full rounded-full bg-accent transition-all" style="width:' + (toFree > 0 ? Math.min(100, (cart.total_price / AB_FREE_SHIPPING) * 100) : 100) + '%"></div>' +
      "</div></div>" +
      '<div class="min-h-0 flex-1 space-y-4 overflow-y-auto pr-1">' +
      shown.map(function (item) {
        var plan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan
          ? item.selling_plan_allocation.selling_plan.name : "";
        var variant = item.variant_title && item.variant_title !== "Default Title" ? item.variant_title : "";
        return (
          '<div class="flex gap-4 rounded-lg bg-muted/60 p-3">' +
          '<div class="h-16 w-16 shrink-0 overflow-hidden rounded-md bg-card">' +
          (item.image ? '<img src="' + esc(item.image) + '&width=160" alt="" class="h-full w-full object-cover">' : "") +
          "</div>" +
          '<div class="min-w-0 flex-1">' +
          '<h4 class="text-sm font-medium leading-snug text-foreground">' + esc(abName(abDecode(item.title))) + "</h4>" +
          (variant ? '<p class="text-sm text-muted-foreground">' + esc(abDecode(variant)) + "</p>" : "") +
          (plan ? '<p class="text-xs font-semibold text-primary">' + esc(abDecode(plan)) + "</p>" : "") +
          '<p class="font-semibold">' + money(item.final_price) + "</p>" +
          "</div>" +
          '<div class="flex flex-col items-end gap-2">' +
          '<button type="button" class="' + AB_BTN_GHOST_ICON + '" data-ab-cart-change="' + esc(item.key) + '" data-ab-delta="0" data-ab-qty="0" aria-label="Remove ' + esc(abDecode(item.title)) + '">' + AB_IC_TRASH + "</button>" +
          '<div class="flex items-center gap-1">' +
          '<button type="button" class="' + AB_BTN_OUTLINE_ICON + '" data-ab-cart-change="' + esc(item.key) + '" data-ab-delta="-1" data-ab-qty="' + item.quantity + '" aria-label="Decrease quantity">' + AB_IC_MINUS + "</button>" +
          '<span class="w-6 text-center text-sm">' + item.quantity + "</span>" +
          '<button type="button" class="' + AB_BTN_OUTLINE_ICON + '" data-ab-cart-change="' + esc(item.key) + '" data-ab-delta="1" data-ab-qty="' + item.quantity + '" aria-label="Increase quantity">' + AB_IC_PLUS + "</button>" +
          "</div></div></div>"
        );
      }).join("") +
      "</div>" +
      '<div class="space-y-4 border-t pt-4">' +
      (savings > 0
        ? '<p class="flex items-center gap-2 rounded-lg bg-accent/10 px-3 py-2 text-sm font-medium text-accent-text">' + AB_IC_PERCENT + "You're saving " + money(savings) + " on this order</p>"
        : "") +
      '<div class="flex items-center justify-between"><span class="text-lg font-semibold">Total</span><span class="text-xl font-bold">' + money(cart.total_price) + "</span></div>" +
      '<p class="text-xs text-muted-foreground">Shipping and taxes calculated at checkout.</p>' +
      '<form action="/cart" method="post"><button type="submit" name="checkout" class="' + AB_BTN_HERO + ' w-full">' + AB_IC_EXTERNAL + "Secure checkout</button></form>" +
      '<a class="flex items-start gap-3 rounded-xl border border-primary/15 bg-info-soft p-3 text-sm text-primary" href="' + esc(guaranteeUrl) + '">' + AB_IC_SHIELD +
      "<span><strong>100-day, 100% money-back guarantee.</strong> <span class=\"underline underline-offset-2\">See terms</span></span></a>" +
      '<ul class="grid grid-cols-3 gap-2 text-center text-xs text-muted-foreground">' +
      '<li class="flex flex-col items-center gap-1">' + AB_IC_STETH + "Physician formulated</li>" +
      '<li class="flex flex-col items-center gap-1">' + AB_IC_FLASK + "3rd-party tested</li>" +
      '<li class="flex flex-col items-center gap-1">' + AB_IC_LOCK + "Secure checkout</li>" +
      "</ul></div>";
  }

  /* Slide-down "added to cart" notification — matches the site's sonner toast. */
  function showToast(message) {
    var host = document.querySelector("[data-ab-toaster]");
    if (!host) {
      host = document.createElement("div");
      host.setAttribute("data-ab-toaster", "");
      host.className = "ab-toaster";
      document.body.appendChild(host);
    }
    var toast = document.createElement("div");
    toast.className = "ab-toast";
    toast.setAttribute("role", "status");
    toast.innerHTML =
      '<span class="ab-toast__icon"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg></span>' +
      "<span>" + esc(message) + "</span>";
    host.appendChild(toast);
    requestAnimationFrame(function () { toast.classList.add("is-in"); });
    setTimeout(function () {
      toast.classList.remove("is-in");
      setTimeout(function () { if (toast.parentNode) toast.parentNode.removeChild(toast); }, 300);
    }, 4000);
  }

  /* Free subscriber bonuses (Dr. Wright call, early-access guide, shipping). The store's
     "Subscription free product" discount makes them $0 only next to a Probio Vitality or
     Tami's Top Three subscription, so they are kept in the cart only while one is present.
     Mirrors syncSubscriberBonuses in src/lib/shopify.ts. */
  var AB_BONUS_IDS = [67622402687167, 67664175661247, 67681054195903];
  var AB_BONUS_HANDLES = ["probio-vitality", "tamis-top-three"];
  function getCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); });
  }
  function postJSON(url, body) {
    return fetch(url, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) });
  }
  function reconcileBonuses(cart) {
    var items = (cart && cart.items) || [];
    var qualifies = items.some(function (i) { return i.selling_plan_allocation && AB_BONUS_HANDLES.indexOf(i.handle) !== -1; });
    var bonus = items.filter(function (i) { return AB_BONUS_IDS.indexOf(i.variant_id) !== -1; });
    var updates = {}, changed = false, seen = {};
    // Exactly one of each bonus while qualifying (the free-product discount covers one unit), none otherwise.
    bonus.forEach(function (i) {
      if (!qualifies || seen[i.variant_id]) { updates[i.key] = 0; changed = true; }
      else { seen[i.variant_id] = true; if (i.quantity !== 1) { updates[i.key] = 1; changed = true; } }
    });
    var missing = qualifies ? AB_BONUS_IDS.filter(function (id) { return !seen[id]; }) : [];
    var chain = Promise.resolve();
    if (changed) chain = chain.then(function () { return postJSON("/cart/update.js", { updates: updates }); });
    if (missing.length) chain = chain.then(function () { return postJSON("/cart/add.js", { items: missing.map(function (id) { return { id: id, quantity: 1 }; }) }); });
    return (changed || missing.length ? chain.then(getCart, function () { return cart; }) : Promise.resolve(cart)).then(orderBonusesLast);
  }
  /* Checkout lists lines in cart order (newest first), so bonuses added after the
     subscription would sit above it. Re-add the regular lines so they come first. */
  function orderBonusesLast(cart) {
    var items = (cart && cart.items) || [];
    var isBonus = function (i) { return AB_BONUS_IDS.indexOf(i.variant_id) !== -1; };
    var firstBonus = items.findIndex(isBonus);
    if (firstBonus === -1 || !items.slice(firstBonus).some(function (i) { return !isBonus(i); })) return cart;
    var regular = items.filter(function (i) { return !isBonus(i); });
    var zero = {}; regular.forEach(function (i) { zero[i.key] = 0; });
    var readd = regular.slice().reverse().map(function (i) {
      var line = { id: i.variant_id, quantity: i.quantity };
      if (i.selling_plan_allocation) line.selling_plan = i.selling_plan_allocation.selling_plan.id;
      if (i.properties && Object.keys(i.properties).length) line.properties = i.properties;
      return line;
    });
    return postJSON("/cart/update.js", { updates: zero })
      .then(function () { return postJSON("/cart/add.js", { items: readd }); })
      .then(getCart, function () { return cart; });
  }

  // One cart load at a time so overlapping updates can't each add the bonuses.
  var abCartQueue = Promise.resolve();
  function loadCart() {
    abCartQueue = abCartQueue.then(function () {
      return getCart()
        .then(reconcileBonuses)
        .then(function (cart) { renderCart(cart); return cart; });
    }).catch(function () {});
    return abCartQueue;
  }

  function changeLine(id, quantity) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: id, quantity: quantity }),
    })
      .then(function () { return loadCart(); })
      .then(function () { if (document.querySelector("[data-ab-cart-page]")) window.location.reload(); })
      .catch(function () {});
  }

  function initCart() {
    document.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-ab-cart-change]");
      if (!btn) return;
      var id = btn.getAttribute("data-ab-cart-change");
      var delta = parseInt(btn.getAttribute("data-ab-delta"), 10);
      var current = parseInt(btn.getAttribute("data-ab-qty"), 10);
      if (isNaN(current)) current = 1;
      var next = delta === 0 ? 0 : Math.max(0, current + delta);
      changeLine(id, next);
    });

    // Ajax add-to-cart: intercept product form submissions.
    document.addEventListener("submit", function (e) {
      var form = e.target;
      if (!form.matches('form[action*="/cart/add"]')) return;
      e.preventDefault();
      var button = form.querySelector('[type="submit"]');
      if (button) button.setAttribute("aria-disabled", "true");
      var data = new FormData(form);
      var payload = {
        items: [
          {
            id: data.get("id"),
            quantity: parseInt(data.get("quantity") || "1", 10) || 1,
            selling_plan: data.get("selling_plan") || undefined,
            properties: (function () {
              var props = {};
              data.forEach(function (v, k) {
                if (k.indexOf("properties[") === 0) props[k.slice(11, -1)] = v;
              });
              return Object.keys(props).length ? props : undefined;
            })(),
          },
        ],
      };
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(payload),
      })
        .then(function (r) {
          return r.json().then(function (json) {
            if (!r.ok) throw new Error(json.description || "Could not add to cart");
            return json;
          });
        })
        .then(function (json) {
          var added = json && json.items && json.items[0] ? json.items[0] : null;
          var title = added ? (added.product_title || added.title || "") : "";
          return loadCart().then(function () {
            openDrawer("cart");
            if (title) showToast(abName(abDecode(title)) + " added to cart");
          });
        })
        .catch(function (err) {
          var note = form.querySelector("[data-ab-add-error]");
          if (note) { note.textContent = err.message; note.hidden = false; }
        })
        .finally(function () {
          if (button) button.removeAttribute("aria-disabled");
        });
    });

    loadCart();
  }

  /* ------------------------------------------------------------- gallery */
  function initGallery() {
    document.querySelectorAll("[data-ab-gallery]").forEach(function (gallery) {
      var stage = gallery.querySelector("[data-ab-stage]");
      var main = stage ? stage.querySelector("img") : null;
      var thumbs = gallery.querySelectorAll("[data-ab-thumb]");
      thumbs.forEach(function (thumb) {
        thumb.addEventListener("click", function () {
          var src = thumb.getAttribute("data-ab-thumb");
          var full = thumb.getAttribute("data-ab-thumb-full") || src;
          if (main) {
            main.src = full;
            main.removeAttribute("srcset");
          }
          thumbs.forEach(function (t) { t.setAttribute("aria-current", t === thumb ? "true" : "false"); });
        });
      });
    });
  }

  /* ------------------------------------------------- price + variant sync */
  function initProduct() {
    var product = document.querySelector("[data-ab-product]");
    if (!product) return;
    var priceEl = product.querySelector("[data-ab-price]");
    var compareEl = product.querySelector("[data-ab-compare]");
    var form = product.querySelector('form[action*="/cart/add"]');

    var update = function () {
      var variant = product.querySelector('select[name="id"], [data-ab-variant-select]');
      var selectedId = variant ? variant.value : null;
      var options = product.querySelectorAll("[data-ab-option]");
      var plan = product.querySelector('input[name="selling_plan"]:checked');
      var price = null;
      var compare = null;
      options.forEach(function (opt) {
        if (String(opt.getAttribute("data-ab-option")) === String(selectedId)) {
          price = parseFloat(opt.getAttribute("data-ab-price"));
          compare = parseFloat(opt.getAttribute("data-ab-compare") || "0");
        }
      });
      if (price == null) return;
      if (plan) {
        var pct = parseFloat(plan.getAttribute("data-ab-discount") || "0");
        if (pct > 0) price = price * (1 - pct / 100);
      }
      if (priceEl) priceEl.textContent = money(Math.round(price * 100));
      if (compareEl) {
        if (compare && compare > price) {
          compareEl.textContent = money(Math.round(compare * 100));
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (form) {
        var qty = form.querySelector('input[name="quantity"]');
        var selected = product.querySelector('select[name="id"] option[value="' + selectedId + '"]');
        var flag = product.querySelector("[data-ab-variant-select]");
        var soldOut = false;
        if (selected) {
          soldOut = selected.getAttribute("data-ab-sold-out") === "true" || selected.getAttribute("data-available") === "false";
        } else if (flag) {
          soldOut = flag.getAttribute("data-ab-sold-out") === "true";
        }
        var button = form.querySelector('[type="submit"]');
        if (button) {
          button.disabled = soldOut;
          button.textContent = soldOut ? "Sold out" : "Add to cart";
        }
        if (qty) qty.disabled = soldOut;
      }
    };

    product.addEventListener("change", update);
    product.addEventListener("click", function (e) {
      if (e.target.matches('input[name="selling_plan"], input[name="id"]')) update();
    });
    update();
  }

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  ready(function () {
    initHeader();
    initDrawers(); initSearch(); initNewsletter();
    initCart();
    initGallery();
    initProduct();
  });
})();

/* Reviews: mirrors the site's Judge.me-backed review list, star summaries and review form.
   Data comes from the site's public review feed because the theme cannot hold the private Judge.me key. */
(function () {
  var API = "https://aging-backwards-wellness.lovable.app/api/public/reviews";
  var STAR = '<path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"/>';
  var BADGE = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="h-3 w-3"><path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"/><path d="m9 12 2 2 4-4"/></svg>';
  var TM = ["D-Immune Vitality Max","Immune Vitality Max Package","Immune Vitality Package","Tami's Top Three","Tami\u2019s Top Three","Quercetin Immune Vitality","Elderberry Immune Vitality","Berberine Gut Vitality","Butyrate Gut Vitality","Zinc Immune Vitality","C-Immune Vitality","D-Immune Vitality","Neurofortify Vitality","Nuerofortify Vitality","Neuro Fortify Vitality","Neuro Revitalize","Neuro Vitality Package","Neuro Package","IgGI Gut Vitality","Gut Vitality Package","Gut Package","Probio Vitality","Mag Vitality","Mag Cleanse","DHA Vitality"].sort(function (a, b) { return b.length - a.length; });
  var TM_RE = new RegExp("\\b(?:" + TM.join("|") + ")(?![\\w-])(?:\u2122|\u00ae)?", "gi");
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
  function tm(s) { return String(s || "").replace(TM_RE, function (m) { return /[\u2122\u00ae]$/.test(m) ? m : m + "\u2122"; }); }
  // Restore product-name trademarks in Shopify product copy, matching the site's display text.
  (function () {
    function run() {
      document.querySelectorAll(".prose, main h1, main h2, main h3").forEach(function (root) {
        var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT), n;
        while ((n = w.nextNode())) { var v = tm(n.nodeValue); if (v !== n.nodeValue) n.nodeValue = v; }
      });
    }
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run); else run();
  })();
  function stars(v, size, empty) {
    size = size || "h-4 w-4";
    var out = '<span class="flex gap-0.5 ' + (empty ? "text-muted-foreground/40" : "text-accent") + '" ' + (empty ? 'role="img" aria-label="No reviews yet"' : 'aria-label="' + v.toFixed(1) + ' out of 5 stars"') + ">";
    for (var i = 0; i < 5; i++) out += '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="' + size + (!empty && i < Math.round(v) ? " fill-current" : "") + '">' + STAR + "</svg>";
    return out + "</span>";
  }
  function countText(n) { return n + " " + (n === 1 ? "review" : "reviews"); }
  var cache = {};
  function get(handle) {
    var key = handle || "__all";
    if (!cache[key]) cache[key] = fetch(API + (handle ? "?handle=" + encodeURIComponent(handle) : "")).then(function (r) { if (!r.ok) throw r; return r.json(); }).catch(function () { delete cache[key]; return null; });
    return cache[key];
  }
  function goToReviews(e) {
    var visible = [].slice.call(document.querySelectorAll("[data-reviews]")).find(function (el) { return el.offsetParent !== null; });
    if (!visible) return;
    e.preventDefault();
    var header = document.querySelector("header");
    var top = visible.getBoundingClientRect().top + window.scrollY - ((header ? header.getBoundingClientRect().height : 0) + 16);
    window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
  }

  function renderSummaries() {
    document.querySelectorAll("[data-ab-rating-summary]").forEach(function (el) {
      get(el.dataset.handle).then(function (d) {
        if (!d || !d.count || d.average == null) {
          if (el.dataset.placeholder !== "true") return;
          el.innerHTML = '<div class="flex items-center gap-2 text-sm text-muted-foreground">' + stars(0, null, true) + '<a href="#reviews" class="font-sans font-semibold underline underline-offset-4 hover:text-foreground">Write a review</a></div>';
        } else {
          el.innerHTML = '<a href="#reviews" class="flex items-center gap-2 text-sm text-muted-foreground underline-offset-4 hover:underline">' + stars(d.average) + '<span><span class="font-semibold text-foreground">' + d.average.toFixed(1) + "</span> · " + countText(d.count) + "</span></a>";
        }
        var a = el.querySelector("a"); if (a) a.addEventListener("click", goToReviews);
      });
    });
  }

  function renderCards() {
    var cards = document.querySelectorAll("[data-ab-card-rating]");
    if (!cards.length) return;
    get(null).then(function (all) {
      if (!all) return;
      cards.forEach(function (el) {
        var r = all[el.dataset.handle];
        if (!r || !r.count) return;
        el.innerHTML = '<a href="' + esc(el.dataset.url) + '" class="flex items-center gap-2 text-sm text-muted-foreground underline-offset-4 hover:underline">' + stars(r.average) + '<span><span class="font-semibold text-foreground">' + r.average.toFixed(1) + "</span> · " + countText(r.count) + "</span></a>";
      });
    });
  }

  function renderList(sec) {
    var handle = sec.dataset.handle;
    get(handle).then(function (d) {
      if (!d || !d.count) return;
      var sum = sec.querySelector("[data-ab-reviews-summary]");
      sum.innerHTML = '<span class="font-sans text-lg font-semibold text-foreground">' + d.average.toFixed(1) + "</span>" + stars(d.average) + countText(d.count);
      sum.classList.remove("hidden"); sum.classList.add("flex");
      var list = sec.querySelector("[data-ab-review-list]");
      list.innerHTML = d.reviews.map(function (r) {
        var date = r.date ? new Date(r.date).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "";
        var media = (r.media || []).filter(function (m) { return /^https:\/\//.test(m.url); }).map(function (m, i) {
          return m.type === "video"
            ? '<video src="' + esc(m.url) + '"' + (m.thumbnailUrl ? ' poster="' + esc(m.thumbnailUrl) + '"' : "") + ' controls playsinline preload="none" aria-label="Video review from ' + esc(r.author) + '" class="aspect-video w-full max-w-sm rounded-lg bg-muted"></video>'
            : '<a href="' + esc(m.url) + '" target="_blank" rel="noopener noreferrer" aria-label="Open review photo ' + (i + 1) + " from " + esc(r.author) + '"><img src="' + esc(m.thumbnailUrl || m.url) + '" alt="Review photo ' + (i + 1) + " from " + esc(r.author) + '" loading="lazy" class="h-28 w-28 rounded-lg border object-cover"></a>';
        }).join("");
        return '<li class="py-5 first:pt-0 last:pb-0">' + stars(r.rating) +
          '<div class="mt-2 flex flex-wrap items-center gap-2"><span class="font-semibold text-foreground">' + esc(r.author) + "</span>" +
          (r.verified ? '<span class="flex items-center gap-1 rounded-full border border-primary/20 px-2 py-0.5 text-xs text-primary">' + BADGE + "Verified buyer</span>" : "") +
          (date ? '<span class="text-xs text-muted-foreground">' + date + "</span>" : "") + "</div>" +
          (r.title ? '<p class="mt-2 font-semibold text-foreground">' + esc(tm(r.title)) + "</p>" : "") +
          '<p class="mt-2 text-sm leading-relaxed text-muted-foreground">' + esc(tm(r.body)) + "</p>" +
          (media ? '<div class="mt-3 flex flex-wrap gap-3">' + media + "</div>" : "") + "</li>";
      }).join("");
      list.classList.remove("hidden");
    });
  }

  function wireForm(sec) {
    var toggle = sec.querySelector("[data-ab-review-toggle]");
    var form = sec.querySelector("[data-ab-review-form]");
    var err = sec.querySelector("[data-ab-review-error]");
    var rating = 0;
    toggle.addEventListener("click", function () {
      var open = form.classList.toggle("hidden") === false;
      toggle.textContent = open ? "Close" : "Write a review";
    });
    sec.querySelectorAll("[data-ab-star]").forEach(function (b) {
      b.addEventListener("click", function () {
        rating = Number(b.dataset.abStar);
        sec.querySelectorAll("[data-ab-star]").forEach(function (x) {
          var n = Number(x.dataset.abStar);
          x.setAttribute("aria-checked", String(n === rating));
          x.querySelector("svg").classList.toggle("fill-current", n <= rating);
        });
      });
    });
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      err.classList.add("hidden");
      if (!rating) { err.textContent = "Please choose a star rating."; err.classList.remove("hidden"); return; }
      var f = new FormData(form);
      var btn = form.querySelector('[type="submit"]'); btn.disabled = true;
      fetch(API, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ productId: sec.dataset.productId, rating: rating, name: String(f.get("name")), email: String(f.get("email")), title: String(f.get("title") || ""), body: String(f.get("body")) }) })
        .then(function (r) { if (!r.ok) throw r; form.classList.add("hidden"); toggle.classList.add("hidden"); sec.querySelector("[data-ab-review-done]").classList.remove("hidden"); delete cache[sec.dataset.handle]; })
        .catch(function () { err.textContent = "Please check your details and try again."; err.classList.remove("hidden"); })
        .finally(function () { btn.disabled = false; });
    });
  }

  function init() {
    renderSummaries();
    renderCards();
    document.querySelectorAll("[data-ab-reviews]").forEach(function (sec) { renderList(sec); wireForm(sec); });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();

/* Shop-all filter pills: same categories as the site's /shop page. */
(function () {
  var root = document.querySelector("[data-ab-shop]");
  if (!root) return;
  var ON = ["bg-primary", "text-primary-foreground"], OFF = ["text-muted-foreground", "hover:bg-accent", "hover:text-accent-foreground"];
  var grid = root.querySelector("[data-ab-shop-grid]");
  var items = [].slice.call(grid.children);
  root.querySelectorAll("[data-ab-shop-filter]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var v = btn.dataset.abShopFilter, n = 0;
      root.querySelectorAll("[data-ab-shop-filter]").forEach(function (b) {
        var a = b === btn; b.setAttribute("aria-pressed", String(a));
        ON.forEach(function (c) { b.classList.toggle(c, a); }); OFF.forEach(function (c) { b.classList.toggle(c, !a); });
      });
      items.forEach(function (el) { var show = (" " + el.dataset.groups + " ").indexOf(" " + v + " ") !== -1; el.style.display = show ? "" : "none"; if (show) n++; });
      // Tami's Top Three always leads Protocols.
      var top = items.find(function (el) { return el.dataset.handle === "tamis-top-three"; });
      if (top) { if (v === "protocols") grid.insertBefore(top, grid.firstChild); else grid.insertBefore(top, items[items.indexOf(top) + 1] || null); }
      root.querySelector("[data-ab-shop-count]").textContent = n + " formulas";
      root.querySelector("[data-ab-shop-empty]").classList.toggle("hidden", n > 0);
    });
  });
})();
